// ══════════════════════════════════════════════════════════════════════════════
//  src/components/teacher/ModalHistorial.jsx
//  LO QUE ESTE PROFESOR HA OBSERVADO DE ESTE ALUMNO
//
//  ── LO QUE NO SALE AQUI, A PROPOSITO ────────────────────────────────────────
//  Lo que OTRO profesor observo del mismo alumno. El servidor filtra por los
//  dos —alumno suyo, evaluaciones suyas— y la pantalla no intenta rodearlo.
//  Criterio ajeno mezclado con el propio sesga el propio: si lees que otro le
//  puso un 2 en fluidez, es dificil no bajar el tuyo.
// ══════════════════════════════════════════════════════════════════════════════

import { useHistorial } from './useProfesor.js';

const COMO_SE_DICE = {
  mas_facil:   'bajar dificultad',
  mantener:    'mantener',
  mas_dificil: 'subir dificultad',
};

/** «2026-08-29T14:02:11+00:00» → «29 ago 2026». */
function cuando(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('es-MX', {
      day: '2-digit', month: 'short', year: 'numeric',
    });
  } catch {
    return iso.slice(0, 10);
  }
}

export default function ModalHistorial({ alumno, onCerrar }) {
  const { data, isLoading, isError, error } = useHistorial(alumno.id);
  const evaluaciones = data?.evaluaciones || [];

  return (
    <div className="pp-overlay" onClick={onCerrar}>
      <div className="pp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pp-modal-t">{alumno.nombre}</div>
        <p className="pp-modal-s">
          Lo que <b>tu</b> has observado. Otro profesor del mismo alumno tiene su
          propio historial, y no se mezclan.
        </p>

        {isLoading && <div className="pp-cargando">Cargando…</div>}

        {isError && <div className="pp-error">{error?.message}</div>}

        {!isLoading && !isError && evaluaciones.length === 0 && (
          <div className="pp-vacio">
            <div className="pp-vacio-t">Todavia no le has evaluado</div>
            <div className="pp-vacio-s">
              Al acabar una clase, dejar las tres señales toma medio minuto y es
              lo que ajusta sus ejercicios.
            </div>
          </div>
        )}

        {evaluaciones.length > 0 && (
          <div className="pp-evals">
            {evaluaciones.map((e) => (
              <div className="pp-eval" key={e.id}>
                <div className="pp-eval-h">
                  <span>
                    {e.fecha_clase
                      ? `CLASE ${e.fecha_clase}${e.hora_clase ? ` · ${e.hora_clase}:00` : ''}`
                      : 'SIN CLASE CONCRETA'}
                  </span>
                  <span>{cuando(e.creada)}</span>
                </div>
                <div className="pp-eval-n">
                  <span>Comprension <b>{e.comprension}</b></span>
                  <span>Fluidez <b>{e.fluidez}</b></span>
                  <span>Confianza <b>{e.confianza}</b></span>
                  <span>→ {COMO_SE_DICE[e.dificultad] || e.dificultad}</span>
                </div>
                {e.nota && <div className="pp-eval-nota">{e.nota}</div>}
              </div>
            ))}
          </div>
        )}

        <div className="pp-acciones">
          <button className="pp-btn pp-btn-ac" onClick={onCerrar}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
